import { useEffect, useMemo, useState } from 'react';
import { getPriceHistories } from '../../services/priceHistory';
import { PriceHistories } from '../../services/priceHistory/types';
import { CHEAP_TICKETS_TAB_AVAILABLE_OPTIONS } from './constants';
import { TripComparatorWidgetProps } from './types';

export const useCheapTicketsTab = (props: TripComparatorWidgetProps) => {
  const { destinationCity, onCheapTicketsContextChange, originCity } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [priceHistories, setPriceHistories] = useState<PriceHistories | null>(
    null,
  );
  const availableValues = useMemo(
    () =>
      priceHistories
        ? Object.keys(priceHistories).filter((key) => !!priceHistories[key])
        : [],
    [priceHistories],
  );

  const hasPriceData = availableValues.length >= 2;
  useEffect(() => {
    onCheapTicketsContextChange?.({
      priceHistories,
      availableValues,
      isLoading,
      hasPriceData,
    });
  }, [
    availableValues,
    isLoading,
    hasPriceData,
    onCheapTicketsContextChange,
    priceHistories,
  ]);

  useEffect(() => {
    const abortController = new AbortController();
    setIsLoading(true);
    getPriceHistories({
      originCityId: originCity.id.toString(),
      destinationCityId: destinationCity.id.toString(),
      timeframeDays: CHEAP_TICKETS_TAB_AVAILABLE_OPTIONS.map((value) =>
        value.toString(),
      ),
      signal: abortController.signal,
    })
      .then((data) => {
        setPriceHistories(data);
      })
      .finally(() => {
        setIsLoading(false);
      });

    return () => abortController.abort();
  }, [destinationCity.id, originCity.id]);

  return {
    isLoading,
    availableValues,
    priceHistories,
    hasPriceData,
  };
};
